import { Button } from '@mui/material';
import { EMobileStatus, IAppointmentCombinedState } from 'models';
import { useDispatch } from 'react-redux';
import { actionCreator as updateFollowUpsActionCreator } from 'store/followups/update';
import { actionCreator } from 'store/home';

export const UpdateFollowUpButton = (props: { appointment: IAppointmentCombinedState }) => {
	const { appointment } = props;
	const dispatch = useDispatch();
	const handleClick = () => {
		dispatch(
			updateFollowUpsActionCreator.INIT_START({
				activityId: appointment.activityId,
				followUpId: appointment.id,
				opportunityId: appointment.opportunityId,
				onSuccess: actionCreator.LOAD_START
			})
		);
		dispatch(updateFollowUpsActionCreator.OPEN_DIALOG());
	};

	if (appointment?.mobileStatus === EMobileStatus.PENDING) {
		return null;
	}

	return (
		<Button
			variant='text'
			onClick={handleClick}
			sx={{
				flex: '1 1 0px',
				borderRadius: '0px 0px 0px 0px',
				minHeight: 50
			}}>
			Update
		</Button>
	);
};
